import type { AppModule } from '@/types/architecture'
import routes from './routes'

/**
 * Fleet Module — Device & Asset Management
 *
 * Provides IT admins a view into employee devices,
 * hardware assets, health metrics, and machine lifecycle management.
 */
const fleetModule: AppModule = {
    id: 'fleet',
    navigation: {
        label: 'Fleet',
        icon: 'monitor-smartphone',
        path: '/fleet/dashboard',
        order: 76,
        moduleKey: 'fleet',
        pages: [
            {
                label: 'Insights',
                path: '/fleet/dashboard',
                icon: 'activity',
            },
            {
                label: 'Assets',
                path: '/fleet/assets',
                icon: 'monitor',
            },
            {
                label: 'Map',
                path: '/fleet/map',
                icon: 'map-pin',
            },
            {
                label: 'Registrations',
                path: '/fleet/registrations',
                icon: 'shield-check',
            },
            {
                label: 'Enrollment Keys',
                path: '/fleet/enrollment-keys',
                icon: 'key-round',
            },
            {
                label: 'Agent Releases',
                path: '/fleet/releases',
                icon: 'package',
            },
        ],
    },
    routes,
}

export default fleetModule
